import { ICoupon } from "./coupon";

export interface ITopCouponsItem {
  coupons: ICoupon[];
  countCoupons: number;
  nextCursor: number;
}

export interface ITopCoupons {
  all: ITopCouponsItem;
  free: ITopCouponsItem;
  newest: ITopCouponsItem;
  best: ITopCouponsItem;
  isLoading: boolean;
  isLoadingMerchant: boolean;
  currentType: ETypeCoupon;
  currentLang: String;
}

export enum ETypeCoupon {
  free = "free",
  newest = "newest",
  best = "best",
  all = "all"
}
